import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { firestoreMethods } from '../../firebase/firestoreMethods';

import AdminHeader from '../AdminHeader';
import SubHeader from '../../SubHeader';
import SiteForm from './SiteForm';


function SiteEdit() {
  const { siteId } = useParams();
  const [ site, setSite ] = useState();

  // fetch site
  useEffect(() => {
    
    let active = true;
    const fetchSite = async () => {
      const newData = await firestoreMethods.getSite(siteId);
      if (active){
        setSite(newData);
      }
    };  

    fetchSite();
    
    return () => {
      active = false;
    };
  }, [siteId]);

  if (!site) return null;
  return (
    <>
      <AdminHeader/>
      <SubHeader nav={-1} display={`Edit ${site.name}`}/> 
      <div className='add-site'>
        <SiteForm mode={"EDIT"} site={site}/>
      </div>
   </>
      
  );
}


export default SiteEdit;
